import { action, computed, makeAutoObservable } from "mobx";
import { CountDown } from "../types";

export class CountDownStore {
  private data: CountDown = {};

  constructor() {
    makeAutoObservable(this);
  }

  @action
  update(item: CountDown) {
    Object.keys(item).forEach((key) => {
      if (!this.data[key]) {
        this.data[key] = item[key];
      }
    });
  }

  @computed
  get(): CountDown {
    return this.data;
  }
}
